import ic_home from '@theme/nav/ic_home.svg'
import ic_home_active from '@theme/nav/ic_home_active.svg'
import ic_game from '@theme/nav/ic_game.svg'
import ic_game_active from '@theme/nav/ic_game_active.svg'
import ic_app from '@theme/nav/ic_app.svg'
import ic_app_active from '@theme/nav/ic_app_active.svg'
import ic_account from '@theme/nav/ic_account.svg'
import ic_account_active from '@theme/nav/ic_account_active.svg'
import ic_discover from '@theme/nav/ic_discover.svg'
import ic_discover_active from '@theme/nav/ic_discover_active.svg'
import ic_hot from '@theme/nav/ic_hot.svg'
import ic_hot_active from '@theme/nav/ic_hot_active.svg'
import ic_sex from '@theme/nav/ic_sex.svg'
import ic_sex_active from '@theme/nav/ic_sex_active.svg'

export const NavIconMap = {
  ic_home,
  ic_home_active,
  ic_game,
  ic_game_active,
  ic_app,
  ic_app_active,
  ic_account,
  ic_account_active,
  ic_discover,
  ic_discover_active,
  ic_hot,
  ic_hot_active,
  ic_sex,
  ic_sex_active,
}
